const storageKey = 'zl_guest_orders';
export const guestOrders = () => {
  try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch { return {}; }
};
export const guestToken = (id) => guestOrders()[id]?.token || '';
export const saveGuestOrder = (order, token) => {
  const saved = guestOrders();
  saved[order.order_id] = { token, products: (order.items || []).map(i => i.product_id) };
  localStorage.setItem(storageKey, JSON.stringify(saved));
};
export const guestPurchaseFor = (productId) => Object.entries(guestOrders()).reverse().find(([, o]) => o.products?.includes(productId));
export const newCheckoutKey = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), b => b.toString(16).padStart(2, '0')).join('');
export const apiErrorMessage = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg).join('. ');
  return 'No se pudo completar la solicitud. Inténtalo de nuevo.';
};